import React, { useEffect } from 'react';
import messages from 'messages';
import VirtualizedSessionList from 'containers/pages/sessions/VirtualizedSessionList';
import useSelectableObject from 'hooks/utils/useSelectableObject';
import { useParams } from 'react-router-dom';
import FieldInput from 'components/input/FieldInput';
import { SORT_DATA_TYPES } from 'utils/sort';
import { useSessionsContext } from 'contexts/SessionsContext';
import SortableListHeader from 'components/list/SortableListHeader';
import useItemSearch from 'hooks/utils/useItemSearch';

const columns = [
  {
    key: 'finishedPercentage',
    label: '%',
    sortable: true,
    desc: false,
    dataType: SORT_DATA_TYPES.NUMBER,
    extraProps: { id: 'listItemStatus' } // this prop is only necessary for styles. Most of the times we don't need it
  },
  {
    key: 'name',
    label: 'Session name',
    sortable: true,
    desc: false,
    dataType: SORT_DATA_TYPES.STRING,
    extraProps: { id: 'listItemMainLabel' } // this prop is only necessary for styles. Most of the times we don't need it
  },
  {
    key: 'type',
    label: 'Type',
    sortable: false,
    extraProps: { id: '' } // Empty id === hidden column
  },
  {
    key: 'startdate',
    label: 'Date',
    default: true,
    sortable: true,
    desc: true,
    dataType: SORT_DATA_TYPES.DATE_STRING,
    extraProps: { id: 'listItemLastLabel' } // this prop is only necessary for styles. Most of the times we don't need it
  }
];

function RecurringSessionsList({ onSelected = null, onClick }) {
  const { entityId, sessionId } = useParams();
  const { selected, setSelected } = useSelectableObject();
  const [{ filteredItems }, setState] = useItemSearch({
    key: 'name'
  });
  const { recurringSessions, loading } = useSessionsContext();

  useEffect(() => {
    if (recurringSessions.length > 0 && loading === false) {
      setState({
        items: recurringSessions,
        sort: columns.find(c => c.default) || columns[0]
      });
    }
  }, [recurringSessions, loading]);

  const onSelectSessionsHandler = selected => {
    setSelected(selected);
    onSelected && onSelected(selected);
  };

  return (
    <>
      <div className="p-tabs__tab-header p-tabs__tab-header-and-list-header">
        <FieldInput
          rounded
          type="text"
          icon="search-grey"
          iconLeft
          onChange={e => setState({ search: e.target.value })}
        />
      </div>

      <VirtualizedSessionList
        refactoring
        activeId={sessionId}
        sortableListHeader={
          <SortableListHeader
            refactoring
            onSort={activeSort => {
              setState({ sort: activeSort });
            }}
            columns={columns}
          />
        }
        variableHeight
        // reCalculateHeight={selected.length > 0}
        entityId={entityId}
        items={[...filteredItems]}
        selectedItems={[...selected]}
        checkableGroups
        // checkable
        emptyMessage={messages.programDetailAthletesEmpty}
        onClick={onClick}
        onSelect={selected => {
          onSelectSessionsHandler(selected);
        }}
      />
    </>
  );
}

export default RecurringSessionsList;
